import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Modal,
    ModalBody,

} from "reactstrap";
import { AvForm } from 'availity-reactstrap-validation';
import {
    FileMetaData,
    FilePreviewContainer,
    FileUploadContainer,
    FormField,
    ImagePreview,
    InputLabel,
    PreviewContainer,
    PreviewList,
    RemoveFileIcon,
    ShowContent,
    UploadFileBtn,
} from "components/Common/file-upload/file-upload.styles";
import imgSuccess from "assets/images/success.png";
import { adminPrefix } from "configs/routePrefix"
import AreasService from "services/Admin/AreasService"
import { SuccessOk } from "configs/statusCode";
import SuccessModal from "components/SucessModal"
import MediaComponent from "../MediaComponent"
import moment from "moment"

const Summary = ({ nextFormStep, compoundData, BuildingData, propertyData, compoundId, setCompoundData, submitForm }) => {
    const [modal, setModal] = useState(false)
    const [city, setCity] = useState(false)

    const areasService = new AreasService()
    useEffect(() => {
        areasService.getList().then(response => {
            if (response && response.status === SuccessOk) {
                const area = response.data.data.filter(area => {
                    return area.id === compoundData.area_id.value
                })
                setCity(area[0].city.name.en)
            }
        })


    }, [])
    return (
        <Row>
            <AvForm onValidSubmit={(e, v) => {
                setModal(true)
            }}>
                <Row className="my-4">
                    <Card className="my-4">
                        <CardBody>

                            <Row className="d-flex justify-content-between my-2">
                                <Col md={6}  >
                                    <Row className="mb-1">
                                        <h5 >Basic Information</h5>
                                        <p >Information About The Compound</p>
                                    </Row>
                                </Col>
                                <Col md={6} className="d-flex flex-row-reverse" >
                                    <button className="btn btn-light btn-lg w-25 btnHeight" onClick={() => {
                                        nextFormStep(0)
                                    }}>Edit</button>
                                </Col>
                            </Row>
                            <Row className="py-2 px-1" style={{ border: "solid 2px #ced4da" }}>
                                <Row>
                                    <Col md={2} className="mb-3  mx-3">
                                        <Row className="my-1" >Compound Name</Row>
                                        <Row className="my-2" ><b className="m-0 p-0">{compoundData?.name?.en}</b></Row>
                                    </Col>
                                    <Col md={2} className="mx-3">
                                        <Row className="my-1" >Developer Name</Row>
                                        <Row className="my-2" ><b className="m-0 p-0">{compoundData?.developer_id?.label}</b></Row>
                                    </Col>
                                    <Col md={2} className="mx-3">
                                        <Row className="my-1" >Building Status</Row>
                                        <Row className="my-2" ><b className="m-0 p-0">{compoundData?.construction_status}</b></Row>
                                    </Col>
                                    <Col md={2} className="mx-3">
                                        <Row className="my-1" >Address</Row>
                                        <Row className="my-2" ><b className="m-0 p-0">{compoundData.address?.en}</b></Row>
                                    </Col>
                                    <Col md={2} className="mx-3">
                                        <Row className="my-1" >Location</Row>
                                        <Row className="my-2" ><b className="m-0 p-0">{compoundData?.area_id?.label}</b></Row>
                                    </Col>
                                    <Col md={2} className="mx-3">
                                        <Row className="my-1" >City</Row>
                                        <Row className="my-2" ><b className="m-0 p-0">{city}</b></Row>
                                    </Col>
                                    {compoundData?.construction_status === "Under Construction" ? <Col md={2} className="mx-3">
                                        <Row className="my-1" >Delivery Date</Row>
                                        <Row className="my-2" ><b className="m-0 p-0">{moment(compoundData.delivery_date).format('YYYY-MM')}</b></Row>
                                    </Col> : null}
                                </Row>
                            </Row>
                        </CardBody>
                    </Card >
                </Row>
                <Row className="my-4">
                    <Card className="my-4">
                        <CardBody>
                            <Row className="d-flex justify-content-between">
                                <Col md={6}  >
                                    <Row className="mb-1">
                                        <h5 >Basic Information</h5>
                                        <p >Information About The Compound</p>
                                    </Row>
                                </Col>
                                <Col md={6} className="d-flex flex-md-row-reverse" >
                                    <button className="btn btn-light btn-lg w-25 btnHeight " onClick={() => {
                                        nextFormStep(0)
                                    }}>Edit</button>
                                </Col>
                            </Row>
                            <Row className="py-2 px-1" style={{ border: "solid 2px #ced4da" }}>
                                <Row>
                                    {compoundData.facilities_ids.map(item => {
                                        return (
                                            <Col md={2} className="mb-3  mx-3">
                                                <Row className="my-2" ><b className="m-0 p-0">{item?.label}</b></Row>
                                            </Col>
                                        )
                                    })}
                                </Row>
                            </Row>
                        </CardBody>
                    </Card >
                </Row>
                <MediaComponent compoundId={compoundId} compoundData={compoundData} setCompoundData={setCompoundData} />
                <Row className="my-4">
                    <Card className="my-4">
                        <CardBody>
                            <Row className="d-flex justify-content-between">
                                <Col md={6}  >
                                    <h5>Buildings Information</h5>
                                    <p>Information related with the Buildings</p>
                                </Col>
                                <Col md={6} className="d-flex flex-md-row-reverse" >
                                    <button className="btn btn-light btn-lg w-25 btnHeight" onClick={() => {
                                        nextFormStep(1)
                                    }}>Edit</button>
                                </Col>
                            </Row>
                            {BuildingData.map(item => {
                                return (
                                    <Row className="py-4 mt-3  px-1" style={{ border: "solid 2px #ced4da" }}>
                                        <Col md={2} className="mb-3  mx-3">
                                            <Row className="my-1" > Building Name</Row>
                                            <Row className="my-2" ><b className="m-0 p-0">{item?.name?.en}</b></Row>
                                        </Col>
                                        {item.selectedCatogory.map((catogory, index) => {
                                            return (<Col md={2} className="mx-3">
                                                <Row className="my-1" >catogory {index + 1}</Row>
                                                <Row className="my-2" ><b className="m-0 p-0">{catogory?.label}</b></Row>
                                            </Col>)
                                        })}
                                        <Col md={2} className="mx-3">
                                            <Row className="my-1" >Floor Number</Row>
                                            <Row className="my-2" ><b className="m-0 p-0">{item?.floors_num}</b></Row>
                                        </Col>
                                    </Row>
                                )
                            })}
                        </CardBody>
                    </Card >
                </Row>
                <Row className="my-4">
                    <Card className="my-4">
                        <CardBody>
                            <Row className="d-flex justify-content-between">
                                <Col md={6}  >
                                    <h5>Properties Information</h5>
                                    <p>Information related with the properties</p>
                                </Col>
                                <Col md={6} className="d-flex flex-md-row-reverse" >
                                    <button className="btn btn-light btn-lg w-25 btnHeight" onClick={() => {
                                        nextFormStep(2)
                                    }}>Edit</button>
                                </Col>
                            </Row>
                            {propertyData.map(item => {
                                return (
                                    <Row className="py-4 mt-3 px-1" style={{ border: "solid 2px #ced4da" }}>
                                        <Col md={2} className="mb-3  mx-3">
                                            <Row className="my-1" >Unit Code</Row>
                                            <Row className="my-2" ><b className="m-0 p-0">{item?.unit_code}</b></Row>
                                        </Col>
                                        <Col md={2} className="mx-3">
                                            <Row className="my-1" >Property Size</Row>
                                            <Row className="my-2" ><b className="m-0 p-0">{item?.built_up_area} SQM</b></Row>
                                        </Col>
                                        <Col md={2} className="mx-3">
                                            <Row className="my-1" >Payment Method</Row>
                                            <Row className="my-2" ><b className="m-0 p-0">{item?.payment_method?.label}</b></Row>
                                        </Col>
                                        <Col md={2} className="mx-3">
                                            <Row className="my-1" >No. of Bedrooms</Row>
                                            <Row className="my-2" ><b className="m-0 p-0">{item?.bedRoom_num}</b></Row>
                                        </Col>
                                        <Col md={2} className="mx-3">
                                            <Row className="my-1" >No. of Bathrooms</Row>
                                            <Row className="my-2" ><b className="m-0 p-0">{item?.bathroom_num}</b></Row>
                                        </Col>
                                        <Col md={2} className="mx-3">
                                            <Row className="my-1" >Finishing</Row>
                                            <Row className="my-2" ><b className="m-0 p-0">{item.selectedFinishingType?.label}</b></Row>
                                        </Col>
                                        <Col md={2} className="mx-3">
                                            <Row className="my-1" >Floor Number</Row>
                                            <Row className="my-2" ><b className="m-0 p-0">{item?.unit_floor_num}</b></Row>
                                        </Col>
                                        <Col md={2} className="mx-3">
                                            <Row className="my-1" >Unit Type</Row>
                                            <Row className="my-2" ><b className="m-0 p-0">{item?.selectUnitType?.label}</b></Row>
                                        </Col>
                                        <Col md={2} className="mx-3">
                                            <Row className="my-1" >Price</Row>
                                            <Row className="my-2" ><b className="m-0 p-0">{toCurrency(item?.price)}</b></Row>
                                        </Col>
                                    </Row>
                                )
                            })}
                        </CardBody>
                    </Card >
                </Row>
                <Row className="my-2">
                    <Card>
                        <CardBody>
                            <Row className="d-flex flex-row-reverse">
                                <Col md={12} className="d-flex flex-row-reverse">
                                    <button type="submit" className="btn btn-success btnHeight w-25  ">Submit</button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card >
                </Row>
                {/* <SuccessModal modal={modal} message={"New Compound has added successfully"} onClick={()=>submitForm()} /> */}
                <Modal isOpen={modal}>
                    <ModalBody>
                        <Card className='overflow-hidden mt-5 mb-3'>
                            <CardBody className="text-center">
                                <img src={imgSuccess} className='mt-3 img-fluid' />
                                <p className='fw-bold font-size-18 fw-bold pt-3 mb-2'>New Compound has added successfully</p>
                                <button className="btn btn-success w-100 mt-3" onClick={() => {
                                    submitForm()
                                }}>Done</button>
                            </CardBody>
                        </Card>
                    </ModalBody>

                </Modal>
            </AvForm>
        </Row>
    )
}

const toCurrency = (number) => {
    const formatter = new Intl.NumberFormat("en-US");
    return formatter.format(number);
}

export default Summary



